import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import flagN9 from './flag_n9.png';
import './Countdown.css';

const WINDOW_DAYS = 30;

// Semi-transparent NS flag painted by .countdown::before (see Countdown.css).
const FLAG_STYLE = { '--countdown-flag': `url(${flagN9})` };

const pad = (n) => String(n).padStart(2, '0');

const Countdown = () => {
  const enabled = typeof window !== 'undefined' && window.enableCountdown === true;
  const targetStr = enabled ? window.countdownTarget : null;
  const target = targetStr ? new Date(targetStr) : null;
  const valid = target && !Number.isNaN(target.getTime());

  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!valid) return undefined;
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, [valid]);

  if (!enabled || !valid) return null;

  const diff = target.getTime() - now.getTime();

  if (diff <= 0) {
    return (
      <section className="countdown countdown--voting" style={FLAG_STYLE} aria-live="polite">
        <span className="live-pulse">
          
          <button
            type="button"
            className="countdown__link"
            onClick={() => window.dispatchEvent(new CustomEvent('newsroll:open'))}
          >
            滚动新闻
          </button>
          <span className="countdown__sep" aria-hidden="true">｜</span>
          <Link to="/seats/negerisembilan/n" className="countdown__link">
            查看选区
          </Link>
        </span>
      </section>
    );
  }

  const totalSec = Math.floor(diff / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  const windowMs = WINDOW_DAYS * 86400 * 1000;
  const start = target.getTime() - windowMs;
  const progress = Math.max(
    0,
    Math.min(100, ((now.getTime() - start) / windowMs) * 100),
  );

  const lang = localStorage.getItem('lang') || 'zh_CN';
  const locale = lang === 'zh_TW' ? 'zh-TW' : 'zh-CN';
  const dateFmt = { year: 'numeric', month: 'long', day: 'numeric' };
  const dateLabel = target.toLocaleDateString(locale, dateFmt);

  const nominationStr =
    typeof window !== 'undefined' ? window.nominationDate : null;
  const nomination = nominationStr ? new Date(nominationStr) : null;
  const nominationLabel =
    nomination && !Number.isNaN(nomination.getTime())
      ? nomination.toLocaleDateString(locale, dateFmt)
      : null;

  return (
    <section className="countdown" style={FLAG_STYLE} aria-label={i18next.t('距离投票日')}>
      <div className="countdown__head">
        <span className="countdown__label">{i18next.t('距离投票日')}</span>
        <span className="countdown__label">{dateLabel}</span>
      </div>
      {nominationLabel && (
        <div className="countdown__nomination">
          {i18next.t('提名日')}：{nominationLabel}
        </div>
      )}
      <div className="countdown__units">
        <div className="countdown__unit">
          <span className="countdown__num">{pad(days)}</span>
          <span className="countdown__name">{i18next.t('天')}</span>
        </div>
        <div className="countdown__unit">
          <span className="countdown__num">{pad(hours)}</span>
          <span className="countdown__name">{i18next.t('时')}</span>
        </div>
        <div className="countdown__unit">
          <span className="countdown__num">{pad(minutes)}</span>
          <span className="countdown__name">{i18next.t('分')}</span>
        </div>
        <div className="countdown__unit">
          <span className="countdown__num">{pad(seconds)}</span>
          <span className="countdown__name">{i18next.t('秒')}</span>
        </div>
      </div>
      
    </section>
  );
};

export default Countdown;
